import { RawTag } from '@/models/api/tags'

export type Decorator = (tag: RawTag) => RawTag

export class Decorators {
  static readonly subscribeAll: Decorator = (tag: RawTag) => ({
    ...tag,
    follow: true,
  })
}
